/**
 * redux/store.ts — Redux Toolkit store with auth + banks + ui slices.
 *
 * No middleware customisation in v1 — the default RTK middleware (thunk +
 * serializability check) is sufficient. If we add saga later it goes here.
 */

import { configureStore } from '@reduxjs/toolkit';

import authReducer from './slices/auth';
import banksReducer from './slices/banks';
import dashboardReducer from './slices/dashboard';
import uiReducer from './slices/ui';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		banks: banksReducer,
		dashboard: dashboardReducer,
		ui: uiReducer,
	},
	middleware: (getDefault) =>
		getDefault({
			// Allow non-serializable Date objects in errors / etc.
			serializableCheck: false,
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
